import { Config } from './config.type'
const config: Config  = {
    "build": {
        "host": "https://graphql0.canvasflow.io",
        "subdirectory": "/",
        "website": "",
        "subscriptionUrl": "",
        "assetDirectory": "/",
        "title": "Hamptons Social",
        "shortTitle": "HS",
        "appKey": "36ba5679-314d-40ac-8bac-2568d08baa6b",
        "language": "en",
        "languages": [
            "en"
        ],
        "about": "",
        "buildNumber": 710519,
        "buildDate": "2025-06-19T21:13:47.764Z",
        "version": "2.10.9"
    },
    "app": {
        "contentProtection": false,
        "admin": true,
        "favorite": false,
        "auth": {
            "enabled": false,
            "type": "cognito",
            "config": {
                "host": "",
                "clientId": "",
                "customerPortalUrl": null
            }
        },
        "hideNavbarOnScroll": false,
        "installationOption": {
            "enabled": false
        },
        "password": {
            "enabled": false,
            "value": ""
        },
        "template": {
            "type": "basic",
            "config": {
                "sections": false,
                "preview": true
            }
        },
        "menu": {
            "links": []
        }
    },
    "issue": {
        "contentType": "responsive-replica",
        "lastLocation": {
            "enabled": false
        }
    },
    "analytics": {
        "tealium": {
            "ChannelID": "",
            "pageType": "",
            "pageDetail": "",
            "pageTemplate": "",
            "projectType": "",
            "url": ""
        },
        "google": {
            "trackerID": "",
            "sampleRate": 1
        },
        "ga4": {
            "trackerID": "",
            "sampleRate": 1
        },
        "gtm": {
            "trackerID": ""
        },
        "googleOptimize": {
            "trackerID": ""
        },
        "onetrust": {
            "id": ""
        },
        "caymland": {
            "domain": ""
        },
        "ackee": {
            "domainId": "",
            "server": ""
        },
        "netstats": {
            "trackerID": ""
        },
        "hotjar": {
            "trackerID": ""
        },
        "hubspot": {
            "trackerID": ""
        },
        "ShareThis": {
            "trackerID": ""
        },
        "cookiefirst": {
            "key": ""
        },
        "cookiehub": {
            "trackerID": ""
        },
        "plausible": {
            "domain": ""
        },
        "matomo": {
            "domain": ""
        }
    }
};
export default config;